<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        :width="widthS"
        destroy-on-close
        :before-close="handleClose">
        <div v-show="isType == '0'">  
          <!-- 批量定额发票  -->
            <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:23%;">
                    <el-form-item label="票据簿" >
                    <el-select  clearable v-model="BatchQuotavalue" placeholder="请选择票据簿"  size="small" @change="ChargeBatchQuota">
                        <el-option v-for="item in BatchQuotaList" :disabled="item.disabled" :key="item.BatchQuotavalue" :label="item.BatchQuotalabel" :value="item.BatchQuotavalue"></el-option>
                    </el-select>
                    </el-form-item>
                  <el-form-item label="票据号" >
                    <el-select  clearable v-model="BillBookvalue" placeholder="请选择票据号"  size="small" @change="ChargeBatchQuotaBook">
                        <el-option v-for="item in BillBookList" :key="item.BillBookvalue" :label="item.BillBooklabel" :value="item.BillBookvalue"></el-option>
                    </el-select>
                  </el-form-item>
                        <el-form-item label="收费项目">
                          <el-cascader
                        v-model="value"
                        :options="osData"
                        @change="chooseNode"></el-cascader>
                  </el-form-item>
                    <el-form-item label="起始编号" > 
                    <el-input v-model="formLabelAlign.startCode" size="small" disabled></el-input>
                </el-form-item>
                  <el-form-item label="张数" > 
                    <el-input v-model="formLabelAlign.sheets" @input="calculate()"  size="small" ></el-input>
                </el-form-item>
                  <el-form-item label="合计金额" > 
                    <el-input v-model="formLabelAlign.amount" size="small" disabled></el-input>
                </el-form-item>
                  <el-form-item label="日期" > 
                  <el-date-picker
                  v-model="selectTime"
                  type="datetime"
                  @change="selectDateTime(selectTime)"
                  placeholder="选择日期时间">
                </el-date-picker>
                </el-form-item>
                  <el-form-item label="备注" > 
                    <el-input v-model="formLabelAlign.remarks" size="small" ></el-input>
                </el-form-item>
            </el-form>      
        </div>
        <div v-show="isType == '1'"> 
          <div style="width:40%;height:400px;margin-left:5%;">
            <div class="osBody">
                <el-tree
                  :data="osDataget"
                  :props="defaultProps"
                  :load="loadNode"
                  lazy
                  show-checkbox
                  @check-change="handleCheckChange"
                  @node-click="chooseCilck"
                ></el-tree>
            </div>
          </div>
        </div>
        <div v-show="isType == '2'" style="margin-left:5%"> 
          <div class="width:30%;height:100%;display:flex;border: 1px solid;"> 
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign"  >
         <el-form-item label="票据类型" >
         <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
            <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
        </el-select>
         </el-form-item>
             <el-form-item :label="formLabelAlign.obj.payer" style="width:336px" > 
       <el-input v-model="formLabelAlign.name" size="small" ></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.Account" style="width:336px"> 
       <el-input v-model="formLabelAlign.Account" size="small" ></el-input>
    </el-form-item>
</el-form>
</div>
<div style="width:30%;margin-left:30%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.NoteBook" >
         <el-select  clearable v-model="BillBookvalue" placeholder="请选择票据簿"  size="small" @change="ChargeBillBook" >
            <el-option v-for="item in BillBookList" :key="item.BillBookvalue" :label="item.BillBooklabel" :value="item.BillBookvalue"></el-option>
        </el-select>
         </el-form-item>
     <el-form-item label="税号" > 
       <el-input v-model="formLabelAlign.DutyNum" size="small" style="width:200px"></el-input>
    </el-form-item>
     <el-form-item :label="formLabelAlign.obj.invoice" > 
       <el-input v-model="formLabelAlign.payuserName" size="small" disabled ></el-input>
    </el-form-item>
          
</el-form>
</div>
<div style="width:30%;margin-left:60%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
              <el-form-item label="票据号" >
         <el-select  clearable v-model="BillNumvalue" placeholder="请选择票据号"  size="small" @change="ChargeBillNums" >
            <el-option v-for="item in BillNumList" :key="item.BillNumvalue" :label="item.BillNumlabel" :value="item.BillNumvalue"></el-option>
        </el-select>
         </el-form-item>
          <el-form-item label="地址"> 
       <el-input v-model="formLabelAlign.address" style="width:200px" size="small" ></el-input>
    </el-form-item>
         <el-form-item :label="formLabelAlign.obj.proceeds" > 
       <el-input v-model="formLabelAlign.payuserName" size="small" disabled></el-input>
    </el-form-item>
    </el-form>
</div>
<div style="width:100%;float:none;margin-top:50px;">
     <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="item" label="项目" >
        <template slot-scope="scope">
      <el-cascader
      :show-all-levels="false"
    v-model="scope.row.asarr"
    :options="osData"
    @change="ChangeOsData"
    :disabled="scope.row.display"
    ></el-cascader>
        </template>
      </el-table-column>
      <el-table-column prop="zjCny" label="应收年月" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.zjCny" size="small"   :disabled="scope.row.display"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unit" size="small" :disabled="scope.row.display"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="数量" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.num" size="small"   @input="Quantity(scope.row.num)"  :disabled="scope.row.display"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.price"   size="small"   @input="unitPrice(scope.row.price)"  :disabled="scope.row.display"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" label="金额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" size="small" disabled  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxRate" label="税率" >
          <template slot-scope="scope">
              <el-input v-model="scope.row.taxRate" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxPaid" label="税额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.taxPaid" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="subjectsCode" label="对应科目">
        <template slot-scope="scope">
              <el-input v-model="scope.row.subjectsCode" size="small"  disabled></el-input>
        </template>
      </el-table-column>
    </el-table>
      <el-button type="primary" size="small" plain @click="AddLine()">添加行</el-button>
      <el-button type="primary" size="small" plain @click="DelLine()">删除行</el-button>
</div>
<div style="width:30%;margin-left:5%;float:left;margin-top:30px;">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
       <el-form-item :label="formLabelAlign.obj.total" > 
       <el-input v-model="hjje" size="small" disabled></el-input>
    </el-form-item>
     <el-form-item :label="formLabelAlign.obj.income" > 
       <el-input v-model="formLabelAlign.hjsr" size="small" disabled></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.amount" > 
       <el-input v-model="formLabelAlign.hjse" size="small" disabled></el-input>
    </el-form-item>
    </el-form>
</div>
<div style="width:30%;margin-left:-1%;float:left;margin-top:30px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.receipt">
         <el-date-picker
      v-model="ReceiptTime"
      type="datetime"
      @change="inTimeDate(ReceiptTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.invoiceDate" > 
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime(BillDateTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
    <el-form-item> 
         <el-radio v-model="radio" v-show="RadioIfE == true" label="0">电子发票</el-radio>
          <el-radio v-model="radio" label="1">纸质发票</el-radio>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:30%;margin-left:30%;float:left;margin-top:-200px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
      <el-form-item :label="formLabelAlign.obj.remarks" > 
        <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
      </el-form-item>
          <el-form-item :label="formLabelAlign.obj.mode" > 
            <el-select  clearable v-model="receiptTypevalue" placeholder="请选择">
          <el-option
            v-for="item in receiptType"
            :key="item.receiptTypevalue"
            :label="item.receiptTypelabel"
            :value="item.receiptTypevalue"
            @change="receiptTypeData">
          </el-option>
  </el-select>
    </el-form-item>
    <el-form-item > 
        <el-radio v-model="print" label="1">打印票据</el-radio>
        <el-radio v-model="print" label="0">无需打印票据</el-radio>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:100%;float:none;height:300px"></div>
        </div>






        <div v-show="isType == '3'" style="margin-left:5%"> 
  <div class="width:30%;height:100%;display:flex;border: 1px solid;"> 
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign"  >
         <el-form-item label="票据类型" >
         <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
            <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
        </el-select>
         </el-form-item>
  <el-form-item :label="formLabelAlign.obj.payer" style="width:336px"> 
       <el-input v-model="formLabelAlign.name" size="small" ></el-input>
    </el-form-item>
          <el-form-item :label="formLabelAlign.obj.Account" style="width:336px"> 
       <el-input v-model="formLabelAlign.Account" size="small" ></el-input>
    </el-form-item>
 
</el-form>
</div>
<div style="width:30%;margin-left:30%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.NoteBook" >
         <el-select  clearable v-model="BillBookvalue" placeholder="请选择票据簿"  size="small" @change="ChargeBillBook" >
            <el-option v-for="item in BillBookList" :key="item.BillBookvalue" :label="item.BillBooklabel" :value="item.BillBookvalue"></el-option>
        </el-select>
         </el-form-item>
 <el-form-item label="税号" > 
       <el-input v-model="formLabelAlign.DutyNum" size="small" style="width:200px"></el-input>
    </el-form-item>
  <el-form-item :label="formLabelAlign.obj.invoice" > 
       <el-input v-model="formLabelAlign.payuserName" size="small" disabled ></el-input>
    </el-form-item>
        
</el-form>
</div>
<div style="width:30%;margin-left:60%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
       <el-form-item label="票据号" >
         <el-select  clearable v-model="BillNumvalue" placeholder="请选择票据号"  size="small" @change="ChargeBillNums" >
            <el-option v-for="item in BillNumList" :key="item.BillNumvalue" :label="item.BillNumlabel" :value="item.BillNumvalue"></el-option>
        </el-select>
         </el-form-item>
           <el-form-item label="地址"> 
       <el-input v-model="formLabelAlign.address" style="width:200px" size="small" ></el-input>
    </el-form-item> 
     <el-form-item :label="formLabelAlign.obj.proceeds" > 
       <el-input v-model="formLabelAlign.payuserName" size="small" disabled></el-input>
    </el-form-item> 
    </el-form>
</div>
<div style="width:100%;float:none;margin-top:50px;">
     <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="item" label="项目" >
        <template slot-scope="scope">
      <el-cascader
      :show-all-levels="false"
    v-model="scope.row.asarr"
    :options="osData"
    @change="ChangeOsData"
    :disabled="scope.row.display"
    ></el-cascader>
        </template>
      </el-table-column>
      <el-table-column prop="zjCny" label="应收年月" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.zjCny" size="small"   :disabled="scope.row.display"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unit" size="small" :disabled="scope.row.display"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="数量" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.num" size="small"   @input="Quantity(scope.row.num)"  :disabled="scope.row.display"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.price"   size="small"   @input="unitPrice(scope.row.price)"  :disabled="scope.row.display"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" label="金额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" size="small" disabled  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxRate" label="税率" >
          <template slot-scope="scope">
              <el-input v-model="scope.row.taxRate" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxPaid" label="税额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.taxPaid" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="subjectsCode" label="对应科目">
        <template slot-scope="scope">
              <el-input v-model="scope.row.subjectsCode" size="small"  disabled></el-input>
        </template>
      </el-table-column>
    </el-table>
      <el-button type="primary" size="small" plain @click="AddLine()">添加行</el-button>
      <el-button type="primary" size="small" plain @click="DelLine()">删除行</el-button>
</div>
<div style="width:30%;margin-left:5%;float:left;margin-top:30px;">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
       <el-form-item :label="formLabelAlign.obj.total" > 
       <el-input v-model="hjje" size="small" disabled></el-input>
    </el-form-item>
     <el-form-item :label="formLabelAlign.obj.income" > 
       <el-input v-model="formLabelAlign.hjsr" size="small" disabled></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.amount" > 
       <el-input v-model="formLabelAlign.hjse" size="small" disabled></el-input>
    </el-form-item>
    </el-form>
</div>
<div style="width:30%;margin-left:-1%;float:left;margin-top:30px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.receipt">
         <el-date-picker
         size="small"
      v-model="ReceiptTime"
      type="datetime"
      @change="inTimeDate(ReceiptTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.invoiceDate" > 
       <el-date-picker
       size="small"
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime(BillDateTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
    <el-form-item> 
         <el-radio v-model="radio" v-show="RadioIfE == true" label="0">电子发票</el-radio>
          <el-radio v-model="radio" label="1">纸质发票</el-radio>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:35%;margin-left:1%;float:left;margin-top:30px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
              <el-form-item :label="formLabelAlign.obj.mode" > 
            <el-select  clearable v-model="receiptTypevalue" size="small" placeholder="请选择">
          <el-option
            v-for="item in receiptType"
            :key="item.receiptTypevalue"
            :label="item.receiptTypelabel"
            :value="item.receiptTypevalue"
            @change="receiptTypeData">
          </el-option>
  </el-select>
    </el-form-item>
       <el-form-item label="邮箱" > 
        <el-input v-model="formLabelAlign.email" size="small" :disabled="EmailT" style="width:220px"></el-input>
      </el-form-item>
      <el-form-item :label="formLabelAlign.obj.remarks" style="width:336px"> 
        <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
      </el-form-item>
    <el-form-item > 
        <el-radio v-model="print" label="1">打印票据</el-radio>
        <el-radio v-model="print" label="0">无需打印票据</el-radio>
    </el-form-item>
     </el-form>
    </div>
          <div style="width:100%;float:none;height:300px"></div>
        </div>























        <div v-show="isType == '4'" style="margin-left:5%"> 
       <div class="width:30%;height:100%;display:flex;border: 1px solid;"> 
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign"  >
         <el-form-item label="票据类型" >
         <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
            <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
        </el-select>
         </el-form-item>

 <el-form-item :label="formLabelAlign.obj.payer" style="width:336px"> 
       <el-input v-model="formLabelAlign.payer" size="small" ></el-input>
    </el-form-item>
       <el-form-item :label="formLabelAlign.obj.Account"  style="width:336px"> 
       <el-input v-model="formLabelAlign.Account" size="small" ></el-input>
    </el-form-item>
</el-form>
</div>
<div style="width:30%;margin-left:30%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.NoteBook" >
         <el-select  clearable v-model="BillBookvalue" placeholder="请选择票据簿"  size="small" @change="ChangeBookS" >
            <el-option v-for="item in BillBookList" :key="item.BillBookvalue" :label="item.BillBooklabel" :value="item.BillBookvalue"></el-option>
        </el-select>
         </el-form-item>
     <el-form-item label="税号" > 
       <el-input v-model="formLabelAlign.DutyNum" size="small" style="width:200px"></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.invoice" > 
       <el-input v-model="formLabelAlign.payee" size="small" disabled ></el-input>
    </el-form-item>
        
</el-form>
</div>
<div style="width:30%;margin-left:60%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
              <el-form-item label="票据号" >
         <el-select  clearable v-model="BillNumvalue" placeholder="请选择票据号"  size="small" @change="ChargeBillT" >
            <el-option v-for="item in BillNumList" :key="item.BillNumvalue" :label="item.BillNumlabel" :value="item.BillNumvalue"></el-option>
        </el-select>
         </el-form-item>
             <el-form-item label="地址"> 
       <el-input v-model="formLabelAlign.address" style="width:200px" size="small" ></el-input>
    </el-form-item>
     <el-form-item :label="formLabelAlign.obj.proceeds" > 
       <el-input v-model="formLabelAlign.payee" size="small" disabled></el-input>
    </el-form-item>
   
    </el-form>
</div>
<div style="width:100%;float:none;margin-top:50px;">
     <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="item" label="项目" >
        <template slot-scope="scope">
      <el-cascader
      :show-all-levels="false"
    v-model="scope.row.feeitemCode"
    :options="osData"
    @change="ChangeOsData"
    disabled
    ></el-cascader>
        </template>
      </el-table-column>
      <el-table-column prop="zjCny" label="应收年月" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.abstractInfo" size="small"  disabled  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unit" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="数量" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.num" size="small"  disabled  @input="Quantity(scope.row.num)" ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.price"   size="small"  disabled @input="unitPrice(scope.row.price)"  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" label="金额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" size="small" disabled  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxRate" label="税率" >
          <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxPaid" label="税额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.tax" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="subjectsCode" label="对应科目">
        <template slot-scope="scope">
              <el-input v-model="scope.row.subjectCode" size="small"  disabled></el-input>
        </template>
      </el-table-column>
    </el-table>
</div>
<div style="width:30%;margin-left:1%;float:left;margin-top:30px;">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
       <el-form-item :label="formLabelAlign.obj.total" > 
       <el-input v-model="hjje" size="small" disabled></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.income" > 
       <el-input v-model="formLabelAlign.money" size="small" disabled></el-input>
    </el-form-item>
   
      <el-form-item :label="formLabelAlign.obj.amount" > 
       <el-input v-model="formLabelAlign.hjse" size="small" disabled></el-input>
    </el-form-item>
    </el-form>
</div>
<div style="width:30%;margin-left:1%;float:left;margin-top:30px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.receipt">
         <el-date-picker
      v-model="ReceiptTime"
      type="datetime"
      @change="inTimeDate(ReceiptTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.invoiceDate" > 
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime(BillDateTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:30%;margin-left:30%;float:left;margin-top:-130px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
      <el-form-item label="作废原因" > 
        <el-input v-model="formLabelAlign.scrapDes" size="small"></el-input>
      </el-form-item>
          <el-form-item :label="formLabelAlign.obj.mode" > 
            <el-select  clearable v-model="receiptTypevalue" placeholder="请选择">
          <el-option
            v-for="item in receiptType"
            :key="item.receiptTypevalue"
            :label="item.receiptTypelabel"
            :value="item.receiptTypevalue"
            @change="receiptTypeData">
          </el-option>
  </el-select>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:100%;float:none;height:300px"></div>
        </div>
        <div v-show="isType == '5'" style="margin-left:5%">  
   <div class="width:30%;height:100%;display:flex;border: 1px solid;"> 
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign"  >
         <el-form-item label="票据类型" >
         <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
            <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
        </el-select>
         </el-form-item>
   <el-form-item :label="formLabelAlign.obj.payer" style="width:336px"> 
       <el-input v-model="formLabelAlign.payer" size="small" ></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.Account" style="width:336px"> 
       <el-input v-model="formLabelAlign.Account" size="small" ></el-input>
    </el-form-item>
 
</el-form>
</div>
<div style="width:30%;margin-left:30%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.NoteBook" >
         <el-select  clearable v-model="BillBookvalue" placeholder="请选择票据簿"  size="small" @change="ChangeBookS" >
            <el-option v-for="item in BillBookList" :key="item.BillBookvalue" :label="item.BillBooklabel" :value="item.BillBookvalue"></el-option>
        </el-select>
         </el-form-item>
          <el-form-item label="税号" > 
       <el-input v-model="formLabelAlign.DutyNum" size="small" style="width:200px"></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.invoice" > 
       <el-input v-model="formLabelAlign.payee" size="small" disabled ></el-input>
    </el-form-item>
           
</el-form>
</div>
<div style="width:30%;margin-left:60%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
            <el-form-item label="票据号" >
         <el-select  clearable v-model="BillNumvalue" placeholder="请选择票据号"  size="small" @change="ChargeBillT" >
            <el-option v-for="item in BillNumList" :key="item.BillNumvalue" :label="item.BillNumlabel" :value="item.BillNumvalue"></el-option>
        </el-select>
         </el-form-item>
            <el-form-item label="地址"> 
       <el-input v-model="formLabelAlign.address" style="width:200px" size="small" ></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.proceeds" > 
       <el-input v-model="formLabelAlign.payee" size="small" disabled></el-input>
    </el-form-item>
    </el-form>
</div>
<div style="width:100%;float:none;margin-top:50px;">
     <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="item" label="项目" >
        <template slot-scope="scope">
      <el-cascader
      :show-all-levels="false"
    v-model="scope.row.feeitemCode"
    :options="osData"
    @change="ChangeOsData"
    disabled
    ></el-cascader>
        </template>
      </el-table-column>
      <el-table-column prop="zjCny" label="应收年月" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.abstractInfo" size="small"  disabled  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unit" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="数量" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.num" size="small"  disabled  @input="Quantity(scope.row.num)" ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.price"   size="small"  disabled @input="unitPrice(scope.row.price)"  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" label="金额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" size="small" disabled  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxRate" label="税率" >
          <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxPaid" label="税额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.tax" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="subjectsCode" label="对应科目">
        <template slot-scope="scope">
              <el-input v-model="scope.row.subjectCode" size="small"  disabled></el-input>
        </template>
      </el-table-column>
    </el-table>

</div>
<div style="width:30%;margin-left:1%;float:left;margin-top:30px;">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
       <el-form-item :label="formLabelAlign.obj.total" > 
       <el-input v-model="hjje" size="small" disabled></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.income" > 
       <el-input v-model="formLabelAlign.money" size="small" disabled></el-input>
    </el-form-item>
   
      <el-form-item :label="formLabelAlign.obj.amount" > 
       <el-input v-model="formLabelAlign.hjse" size="small" disabled></el-input>
    </el-form-item>
    </el-form>
</div>
<div style="width:30%;margin-left:1%;float:left;margin-top:30px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.receipt">
         <el-date-picker
      v-model="ReceiptTime"
      type="datetime"
      @change="inTimeDate(ReceiptTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.invoiceDate" > 
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime(BillDateTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:30%;margin-left:5%;float:left;margin-top:30px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
      <el-form-item :label="formLabelAlign.obj.remarks" > 
        <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
      </el-form-item>
          <el-form-item :label="formLabelAlign.obj.mode" > 
            <el-select  clearable v-model="receiptTypevalue" placeholder="请选择">
          <el-option
            v-for="item in receiptType"
            :key="item.receiptTypevalue"
            :label="item.receiptTypelabel"
            :value="item.receiptTypevalue"
            @change="receiptTypeData">
          </el-option>
  </el-select>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:100%;float:none;height:300px"></div>
        </div>
        <div v-show="isType == '6'" style="margin-left:5%">  
            <div class="width:30%;height:100%;display:flex;border: 1px solid;"> 
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign"  >
         <el-form-item label="票据类型" >
         <el-select  clearable v-model="BillTypevalue" placeholder="请选择票据类型"  size="small" @change="ChargeBillType" >
            <el-option v-for="item in BillTypeList" :key="item.BillTypevalue" :label="item.BillTypelabel" :value="item.BillTypevalue"></el-option>
        </el-select>
         </el-form-item>
  <el-form-item :label="formLabelAlign.obj.payer" style="width:336px"> 
       <el-input v-model="formLabelAlign.payer" size="small" ></el-input>
    </el-form-item>
     <el-form-item :label="formLabelAlign.obj.Account" style="width:336px"> 
       <el-input v-model="formLabelAlign.Account" size="small" ></el-input>
    </el-form-item>
</el-form>
</div>
<div style="width:30%;margin-left:30%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
         <el-form-item :label="formLabelAlign.obj.NoteBook" >
         <el-select  clearable v-model="BillBookvalue" placeholder="请选择票据簿"  size="small" @change="ChangeBookS" >
            <el-option v-for="item in BillBookList" :key="item.BillBookvalue" :label="item.BillBooklabel" :value="item.BillBookvalue"></el-option>
        </el-select>
         </el-form-item>
          <el-form-item label="税号" > 
       <el-input v-model="formLabelAlign.DutyNum" size="small" style="width:200px"></el-input>
    </el-form-item> 
            <el-form-item :label="formLabelAlign.obj.invoice" > 
       <el-input v-model="formLabelAlign.payee" size="small" disabled ></el-input>
    </el-form-item>
</el-form>
</div>
<div style="width:30%;margin-left:60%;float:left;margin-top:-190px">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
       <el-form-item label="票据号" >
         <el-select  clearable v-model="BillNumvalue" placeholder="请选择票据号"  size="small" @change="ChargeBillT" >
            <el-option v-for="item in BillNumList" :key="item.BillNumvalue" :label="item.BillNumlabel" :value="item.BillNumvalue"></el-option>
        </el-select>
         </el-form-item>
         <el-form-item label="地址"> 
       <el-input v-model="formLabelAlign.address" style="width:200px" size="small" ></el-input>
    </el-form-item>
          <el-form-item :label="formLabelAlign.obj.proceeds" > 
       <el-input v-model="formLabelAlign.payee" size="small" disabled></el-input>
    </el-form-item>
    </el-form>
</div>
<div style="width:100%;float:none;margin-top:50px;">
     <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="item" label="项目" >
        <template slot-scope="scope">
      <el-cascader
      :show-all-levels="false"
    v-model="scope.row.feeitemCode"
    :options="osData"
    @change="ChangeOsData"
    disabled
    ></el-cascader>
        </template>
      </el-table-column>
      <el-table-column prop="zjCny" label="应收年月" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.abstractInfo" size="small"  disabled  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unit" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="数量" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.num" size="small"  disabled  @input="Quantity(scope.row.num)" ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.price"   size="small"  disabled @input="unitPrice(scope.row.price)"  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" label="金额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" size="small" disabled  ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxRate" label="税率" >
          <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="taxPaid" label="税额" >
        <template slot-scope="scope">
              <el-input v-model="scope.row.tax" size="small" disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="subjectsCode" label="对应科目">
        <template slot-scope="scope">
              <el-input v-model="scope.row.subjectCode" size="small"  disabled></el-input>
        </template>
      </el-table-column>
    </el-table>
</div>
<div style="width:30%;margin-left:1%;float:left;margin-top:30px;">
    <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
      <el-form-item :label="formLabelAlign.obj.total" > 
       <el-input v-model="hjje" size="small" disabled></el-input>
    </el-form-item>
     <el-form-item :label="formLabelAlign.obj.income" > 
       <el-input v-model="formLabelAlign.money" size="small" disabled></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.amount" > 
       <el-input v-model="formLabelAlign.hjse" size="small" disabled></el-input>
    </el-form-item>
    </el-form>
</div>
<div style="width:30%;float:left;margin-top:30px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.receipt">
         <el-date-picker
      v-model="ReceiptTime"
      type="datetime"
      @change="inTimeDate(ReceiptTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
        <el-form-item :label="formLabelAlign.obj.invoiceDate" > 
       <el-date-picker
      v-model="BillDateTime"
      type="datetime"
      @change="inDateTime(BillDateTime)"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:30%;margin-left:30%;float:left;margin-top:-130px;">
     <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
      <el-form-item :label="formLabelAlign.obj.remarks" > 
        <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
      </el-form-item>
          <el-form-item :label="formLabelAlign.obj.mode" > 
            <el-select  clearable v-model="receiptTypevalue" placeholder="请选择">
          <el-option
            v-for="item in receiptType"
            :key="item.receiptTypevalue"
            :label="item.receiptTypelabel"
            :value="item.receiptTypevalue"
            @change="receiptTypeData">
          </el-option>
  </el-select>
    </el-form-item>
     </el-form>
          </div>
          <div style="width:100%;float:none;height:300px"></div>
        </div>         
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CashPledgeDialog",
  data() {
    return {
      selectTime:"",
      selectTimeDate:"",
   osDataget: [],
   defaultProps: { children: 'children', label: 'label', isLeaf:(data,node) =>{
       if(node.level===4){ return  true}   // 根据需要进行条件判断添加is-leaf类   return  true
    }},
    tableData:[],
    widthS:"80%",
    total:"",
    radio:"1",
    print:"0",
    isType:"",
    options:[],
    value:'',
    BillDateTime:"",
    optionsone: [],
    valueone: '',
    dialogVisible: false,
    title:"标题",
    titleone:"",
    labelPosition:'right',
    formLabelAlign:{},
    type:"",
    mangroupId:"",
    judge:true,
    Pid:"",
    mangroupName:"",
    typeId:"",
    typeName:"",
    groupId:"",
    BillTypeList:[],
    BillTypevalue:"",
        BillNumList:[],
    BillNumvalue:"",
        BillBookList:[],
    BillBookvalue:"",
    BatchQuotaList:[],
    BatchQuotavalue:"",
    unitPriceval:"",
    Quantityval:"",
    receiptlist:[],
    receiptval:"",
    receiverList:[],
    receiverval:"",
    receiverId:"",
    ReceiptTime:"",
    osData:[],
    osDatavalue:"",
    projectId:'',
    customerId:"",
    ItemTraverse:"",
    feeItemName:"",
    feeItemCode:"",
    maxMoney:"",
    startInvoiceHm:0,
    apartment:[],
    ErgodicityArr:[],
    taxRatelength:0,
    valueosData:"",
    billIds:[],
    projectIdStr:"",
    customerIdStr:"",
    receiptType:[],
    receiptTypevalue:"",
    billIdStr:[],
    isDaily:"",
    user:{},
    hjje:"",
    TcLtableData:[],
    RadioIfE:true,
    IsDay:"",
    EmailT:true,
    
    };
  },
  watch:{
    dialogVisible(val){
      if(val == true){
        if(this.title == "合并收款"){
          this.widthS = "50%"
        }else if(this.title == "其他收费票据信息"){
          this.RadioIfE = false
          this.IsDay = "1"
        }else if(this.title == "收款确定"){
          this.IsDay = "0"
        }else{
          // POST_BILLSBYSTU
        }
      }
    },
    radio(val){
      if(val == "0"){
        this.EmailT = false
      }else{
        this.EmailT = true
      }
    }
    // EmailT

  },
  methods: {
    handleCheckChange(data, checked, indeterminate){
      if(checked==true){
        if(data.roomId!=undefined&&data.roomId!=null){
          this.apartment.push(data)
        }
      }else{
        for (var i = 0; i < this.apartment.length; i++) {
            if ((this.apartment[i].roomId).indexOf(data.roomId) > -1) {
               var index = i;
                this.apartment.splice(index, 1);
            }
        }
      }
    },
    ChangeBookS(){
   // 选择票据簿
        this.$http.get("/charge/web/chargeInvoiceInhouse/getInvoiceOwnOpend?invoiceDm="+this.BillBookvalue).then((res)=>{
          let data = res.data.data
          let arr = []
          for(let val of data){
            let obj  = {
              "BillNumvalue":val.invoiceHm,
              "BillNumlabel":val.invoiceHm,
              "type":val.invoiceDm,
            }
            arr.push(obj)
          }
          this.BillNumList = arr
        })
    },
    chooseCilck(data,Node){
      if(data.children !=null && data.orgId == null){
        // 分公司
      }else if(data.children !=null && data.orgId != null){
        if(this.ErgodicityArr.length==0){
          this.ErgodicityArr.push(data)
        }else{
          for(let val of this.ErgodicityArr){
            if(val.id == data.id){
            }else{
              this.ErgodicityArr.push(data)
            }
          }
        }
        this.$emit('DailyChargeTree',data)
      }
    },
      loadNode(node, resolve) {
           if(node.data.children != null){
               return resolve(node.data.children);
           }else{
             if(node.data.children == null && node.data.orgId == null){
               if(node.data.roomId){
                         setTimeout(() => {
                            const data = [];
                            resolve(data);
                          }, 500);
               }else{
                  let obj = {
                    "floorId":node.data.id,
                    "roomStatus":this.roomStatus
                  }
                   this.$http.post(this.$requestUrl.GET_FLOOR_LIST,obj).then((res) => {
                     let data = res.data.data
                 if(data!=null){
                       for(let i = 0;i<data.length;i++){
                          if(data[i].roomId){
                                setTimeout(() => {
                                  for(let val of data){
                                      val.label = val.roomName
                                  }
                                  resolve(data);
                                }, 500);
                          }else{
                            return resolve()
                          }
                       }
                     }else{
                      return  resolve()
                     }
                   })
               }
             }else{
               return resolve()
             }
           }
      },
    ChangeOsData(res){
      for(let val of this.ItemTraverse){
          if(res[1] == val.feeCode){
            for(let vs of this.tableData){
              if(vs.id == ""){
                vs.maintenanceCost = val.maintenanceCost
                vs.subjectsCode = val.subjectsCode
                vs.feeName = val.feeName
                vs.feeitemCode = val.feeCode
              }
            }
            this.feeItemName = val.feeName
            this.feeItemCode = val.feeCode
          }
        }
    },
      aggregate(){
        //   金额合计
        let num = (this.unitPriceval*1)*(this.Quantityval*1)
        let mon = (num*1).toFixed(2)
        let arr =[]
        for(let val of this.tableData){
             if(val.id == ""){
            val.unitPrice = mon
          }
          arr.push(val.unitPrice)
        }
        this.tableData = this.TcLtableData
        let sum = 0;
        arr.forEach(item =>{
            sum = sum + item*1
        })
        this.formLabelAlign.hjsr = sum.toFixed(2)
        this.hjje = this.formLabelAlign.hjsr
      },

      unitPrice(val){
          // 单价
          this.unitPriceval = val
          this.aggregate()
      },
      Quantity(val){
          // 数量
          this.Quantityval = val
          this.aggregate()
      },
    modification(){

      if(this.isType == "0"){
        // 批量定额发票
        if(this.BatchQuotaList[0].disabled){
         this.dialogVisible = false
       }else{
         let obj = {
            "projectId":this.projectId,
            "invoiceHm":this.BatchQuotavalue,
            "invoiceDm":this.BillBookvalue,
            "money":this.formLabelAlign.amount,
            "customerId":this.customerId,
            "num":this.formLabelAlign.sheets*1,
            "feeItemCode": this.feeItemCode,
            "feeItemName": this.feeItemName,
            "remarks": this.formLabelAlign.remarks,
            "kprq":this.selectTimeDate,
            "startInvoiceHm":this.startInvoiceHm
          }
          if(obj.num !=NaN){
            this.$http.post(this.$requestUrl.POST_BATCH_SAVE,obj).then((res)=>{
                if(res.data.code==200){
                  this.dialogVisible = false
                }else{
                this.$message({
                  message:res.data.msg,
                  type: 'warning'
                });
                this.dialogVisible = false
                }
              })
          }
       }
      }else if(this.isType == "1"){
           for(var i=0; i<this.ErgodicityArr.length; i++){
            for(var j=i+1; j<this.ErgodicityArr.length; j++){
                if(this.ErgodicityArr[i].id==this.ErgodicityArr[j].id){ 
                    this.ErgodicityArr.splice(j,1);
                    j--;
                }
            }
          }
        let projectIds = []
        let roomIds = []
        let customerIds = []
        for(let val of this.ErgodicityArr){
          projectIds.push(val.id)
        }
        for(let val of this.apartment){
          roomIds.push(val.roomId)
          customerIds.push(val.customerId)
        }
        let objects = {
          "projectIds":projectIds,
          "roomIds":roomIds,
          "customerIds":customerIds,
        }
        this.$emit('MergeObject',objects)
        let obj = {
          "roomIds":roomIds,
          "customerIds":customerIds,
        }
        this.$http.post(this.$requestUrl.POST_MERGE,obj).then((res)=>{
            if(res.data.code == 200){
              this.dialogVisible = false
              this.$message({
              message: '合并成功',
              type: 'success'
            });
              this.$emit('MergeDate',res.data.data)
            }else{
              this.$message.error(result.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
      }else if(this.isType == "2"){

             for(let val of this.tableData){
          val.billIds = this.billIdStr
         delete val.asarr
         delete val.display
       }
       for(let val of this.receiptType){
         
         if(val.receiptTypevalue == this.receiptTypevalue){
           this.receiptTypelabel = val.receiptTypelabel
         }
       }
       if(this.radio == "1"){
         if(this.formLabelAlign.hjse == "" || this.formLabelAlign.hjse == null){
           this.formLabelAlign.hjse = 0
         }
         for(let val of this.tableData){
           val.disState = "1"
           val.zjJe = val.unitPrice
         }
      let obj = {
        "pjlx":this.BillTypevalue, // 选择票据类型
        "invoiceHm":this.BillNumvalue, // 选择票据号
        "invoiceDm":this.BillBookvalue, // 选择票据簿
        "ein":this.formLabelAlign.DutyNum,// 税号
        "address":this.formLabelAlign.address, // 地址
        "payer":this.formLabelAlign.name, // 付款人
        "account":this.formLabelAlign.Account, // 账户
        // 表单
        "bills":this.tableData,
        "remarks":this.formLabelAlign.remarks, // 备注
        "invoiceMan":this.formLabelAlign.payuserName, // 开票人
        "hjsr":this.formLabelAlign.hjsr, // 合计
        "hjse":this.formLabelAlign.hjse, // 合计税额
        "zjSkrq":this.BillDateTime, // 收款日期
        "makeInvoiceDate":this.ReceiptTime, // 开票日期
        "ticket":this.radio, // 纸质发票
        "payee":this.formLabelAlign.payuserName,// 收款人
        "ticket2":this.print,// 是否需要票据
        "projectId":this.projectIdStr,
        "customerId":this.customerIdStr,
        "payMethod":this.receiptTypelabel,
        "hjje":this.hjje,
        "isDay":this.isDaily,
     }
     if(this.BillTypevalue == undefined || this.BillTypevalue == ""){
        this.$message({
          message: '请完善票据类型',
          type: 'warning'
        });
     }else if(obj.invoiceDm == undefined || obj.invoiceDm == ""){
 this.$message({
          message: '请完善票据簿',
          type: 'warning'
        });
     }else if(obj.invoiceHm == undefined || obj.invoiceHm == ""){
 this.$message({
          message: '请完善票据号',
          type: 'warning'
        });
     }else if(obj.zjSkrq == undefined || obj.zjSkrq == ""){
 this.$message({
          message: '请完善收款日期',
          type: 'warning'
        });
     }else if(obj.makeInvoiceDate == undefined || obj.makeInvoiceDate == ""){
 this.$message({
          message: '请完善开票日期',
          type: 'warning'
        });
     }else if(obj.payMethod == undefined || obj.payMethod == ""){
 this.$message({
          message: '请完善收款方式',
          type: 'warning'
        });
     }else{
        this.$http.post(this.$requestUrl.POST_CONFIRM_SAVE,obj).then((res)=>{
          if(res.data.code == 200){
            this.$message({
              message: '收款成功',
              type: 'success'
            });
            this.dialogVisible = false
            this.$emit("Visible",false)
          }else if(res.data.code == 500){
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }else if(res.data.code == 400){
              this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }else{
              this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
     }
       }
      }else if(this.isType == "3"){
        
       for(let val of this.tableData){
          val.billIds = this.billIdStr
         delete val.asarr
         delete val.display
       }
       for(let val of this.receiptType){
         
         if(val.receiptTypevalue == this.receiptTypevalue){
           this.receiptTypelabel = val.receiptTypelabel
         }
       }
       if(this.radio == "1"){
      let obj = {
        "pjlx":this.BillTypevalue, // 选择票据类型
        "invoiceHm":this.BillNumvalue, // 选择票据号
        "invoiceDm":this.BillBookvalue, // 选择票据簿
        "ein":this.formLabelAlign.DutyNum,// 税号
        "address":this.formLabelAlign.address, // 地址
        "payer":this.formLabelAlign.name, // 付款人
        "account":this.formLabelAlign.Account, // 账户
        "email":this.formLabelAlign.email,
        // 表单
        "bills":this.tableData,
        "remarks":this.formLabelAlign.remarks, // 备注
        "invoiceMan":this.formLabelAlign.payuserName, // 开票人
        "hjsr":this.formLabelAlign.hjsr, // 合计
        "hjse":this.formLabelAlign.hjse, // 合计税额
        "zjSkrq":this.BillDateTime, // 收款日期
        "makeInvoiceDate":this.ReceiptTime, // 开票日期
        "ticket":this.radio, // 纸质发票
        "payee":this.formLabelAlign.payuserName,// 收款人
        "ticket2":this.print,// 是否需要票据
        "projectId":this.tableData[0].projectId,
        "customerId":this.customerIdStr,
        "payMethod":this.receiptTypelabel,
        "hjje":this.hjje,
        "isDay":this.isDaily,
     }
     if(this.BillTypevalue == undefined || this.BillTypevalue == ""){
        this.$message({
          message: '请完善票据类型',
          type: 'warning'
        });
     }else if(obj.invoiceDm == undefined || obj.invoiceDm == ""){
 this.$message({
          message: '请完善票据簿',
          type: 'warning'
        });
     }else if(obj.invoiceHm == undefined || obj.invoiceHm == ""){
 this.$message({
          message: '请完善票据号',
          type: 'warning'
        });
     }else if(obj.zjSkrq == undefined || obj.zjSkrq == ""){
 this.$message({
          message: '请完善收款日期',
          type: 'warning'
        });
     }else if(obj.makeInvoiceDate == undefined || obj.makeInvoiceDate == ""){
 this.$message({
          message: '请完善开票日期',
          type: 'warning'
        });
     }else if(obj.payMethod == undefined || obj.payMethod == ""){
 this.$message({
          message: '请完善收款方式',
          type: 'warning'
        });
     }else{
        this.$http.post(this.$requestUrl.POST_CONFIRM_SAVE,obj).then((res)=>{
          if(res.data.code == 200){
            this.$message({
              message: '收款成功',
              type: 'success'
            });
            this.dialogVisible = false
            this.$emit("Visible",false)
          }else if(res.data.code == 500){
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
     }
       }else{
      let obj = {
        "pjlx":this.BillTypevalue, // 选择票据类型
        "invoiceHm":this.BillNumvalue, // 选择票据号
        "invoiceDm":this.BillBookvalue, // 选择票据簿
        "ein":this.formLabelAlign.DutyNum,// 税号
        "address":this.formLabelAlign.address, // 地址
        "payer":this.formLabelAlign.name, // 付款人
        "account":this.formLabelAlign.Account, // 账户
        "email":this.formLabelAlign.email,
        // 表单
        "bills":this.tableData,
        "remarks":this.formLabelAlign.remarks, // 备注
        "invoiceMan":this.formLabelAlign.payuserName, // 开票人
        "hjsr":this.formLabelAlign.hjsr, // 合计
        "hjse":this.formLabelAlign.hjse, // 合计税额
        "zjSkrq":this.BillDateTime, // 收款日期
        "makeInvoiceDate":this.ReceiptTime, // 开票日期
        "ticket":this.radio, // 纸质发票
        "payee":this.formLabelAlign.payuserName,// 收款人
        "ticket2":this.print,// 是否需要票据
        "projectId":this.tableData[0].projectId,
        "customerId":this.customerIdStr,
        "payMethod":this.receiptTypelabel,
        "hjje":this.hjje,
        "isDay":this.isDaily,
     }
     if(obj.zjSkrq == undefined || obj.zjSkrq == ""){
 this.$message({
          message: '请完善收款日期',
          type: 'warning'
        });
     }else if(obj.makeInvoiceDate == undefined || obj.makeInvoiceDate == ""){
 this.$message({
          message: '请完善开票日期',
          type: 'warning'
        });
     }else if(obj.payMethod == undefined || obj.payMethod == ""){
 this.$message({
          message: '请完善收款方式',
          type: 'warning'
        });
     }else{
        this.$http.post(this.$requestUrl.POST_CONFIRM_SAVE,obj).then((res)=>{
          if(res.data.code == 200){
            this.$message({
              message: '收款成功',
              type: 'success'
            });
            this.dialogVisible = false
            this.$emit("Visible",false)
          }else if(res.data.code == 500){
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
     }
       }
      }else if(this.isType == "4"){
        delete this.formLabelAlign.obj
      this.$http.post(this.$requestUrl.POST_WEB_SCARPINVOICE,this.formLabelAlign).then((res)=>{
        if(res.data.code == 200){
            this.$message({
              message: '作废成功',
              type: 'success'
            });
          this.$emit("Visible",false)
          this.dialogVisible = false
        }else{
          this.$emit("Visible",false)
          this.dialogVisible = false
          this.$message({
              message: res.data.msg,
              type: 'warning'
            });
        }
      })
      }else if(this.isType == "5"){
         delete this.formLabelAlign.obj
        this.$http.post(this.$requestUrl.POST_BILLREOPEN,this.formLabelAlign).then((res)=>{
            if(res.data.code == 200){
               let obj = {
                "BillType":"票据类型",
                "NoteBook":"票据簿",
                "NoteNum":"票据号",
                "payer":"付款人",
                "DutyNum":"税号",
                "Account":"账号",
                "Site":"地址",
                "total":"合计",
                "income":"合计收入",
                "amount":"合计税额",
                "remarks":"备注",
                "receipt":"收款日期",
                "mode":"收款方式",
                "hint":"提示用户电子发票有附加信息：",
                "invoice":"开票人",
                "proceeds":"收款人",
                "invoiceDate":"开票日期"
          }
          this.formLabelAlign.obj = obj
          this.$emit("Visible",false)
          this.dialogVisible = false
        }else{
          this.$emit("Visible",false)
          this.dialogVisible = false
          this.$message({
              message: res.data.msg,
              type: 'warning'
            });
        }
        })
      }else if(this.isType == "6"){
         this.dialogVisible = false
      }
    },
    AddLine(){
              // 添加行
          let obj = {
            "subjectsCode": "",
            "num": "",
            "unit": "月",
            "disState": "0",
            "id": "",
            "zjCny": "",
            "zjJe":0,
            "feeitemCode": "",
            "feeName": "",
            "price":0,
            "ext2": "",
            "remarks": "",
            "taxRate": 0,
            "taxPaid":0,
            "maintenanceCost":"",
          }
          this.tableData.push(obj)
      },
      DelLine(){
        // 删除行
        if(this.tableData.length ==this.taxRatelength){
        }else{
          this.tableData.pop()
        }
      },
      ChargeBillType(){
        // 选择票据类型
        this.$http.get("/charge/web/chargeInvoiceInhouse/selectInvioce?typeId="+this.BillTypevalue).then((res)=>{
          let data = res.data.data
          let arr = []
          for(let val of data){
            let obj = { 
              "BillBooklabel":val.groupNo,
              "BillBookvalue":val.groupNo,
              "typeName":val.typeName,
              "typeId":val.typeId
            }
            arr.push(obj)
          }
          this.BillBookList = arr
        })
      },
      ChargeBillNums(){
      for(let val of this.BillNumList){
          if(this.BillNumvalue == val.BillNumvalue){
            // this.InvoiceBill(val)
            // console.log(val)
          }
        }
      },
      ChargeBillT(){
        // 选择票据号
        for(let val of this.BillNumList){
          if(this.BillNumvalue == val.BillNumvalue){
            this.InvoiceBill(val)
          }
        }
      },
      InvoiceBill(val){
          this.$http.get("/charge/web/chargeInvoiceInhouse/getInvoiceBills?invoiceDm="+val.type+"&"+"invoiceHm="+val.BillNumvalue).then((res)=>{    
            console.log(res)                                                                 
            let data = res.data.data
            let date = res.data.data.infos
            this.tableData = date
             let obj = {
                "BillType":"票据类型",
                "NoteBook":"票据簿",
                "NoteNum":"票据号",
                "payer":"付款人",
                "DutyNum":"税号",
                "Account":"账号",
                "Site":"地址",
                "total":"合计",
                "income":"合计收入",
                "amount":"合计税额",
                "remarks":"备注",
                "receipt":"收款日期",
                "mode":"收款方式",
                "hint":"提示用户电子发票有附加信息：",
                "invoice":"开票人",
                "proceeds":"收款人",
                "invoiceDate":"开票日期"
          }
          data.obj = obj
          data.makeInvoiceDatetime = data.makeInvoiceDate.replace("T"," ").substring(0,18)
          this.BillDateTime = data.makeInvoiceDatetime
          data.zjSkrqtime = data.zjSkrq.replace("T"," ").substring(0,18)
          this.ReceiptTime=data.zjSkrqtime
          this.formLabelAlign = data
          this.receiptTypevalue = data.payMethod
          })
      },
      ChargeBillBook(){
        // 选择票据簿
        this.$http.get("/charge/web/chargeInvoiceInhouse/getInvoicesByDm?invoiceDm="+this.BillBookvalue).then((res)=>{
          let data = res.data.data
          let arr = []
          for(let val of data){
            let obj  = {
              "BillNumvalue":val.invoiceHm,
              "BillNumlabel":val.invoiceHm,
              "type":val.invoiceDm,
            }
            arr.push(obj)
          }
          this.BillNumList = arr
        })
      },
      ChargeBatchQuotaBook(res){
        for(let val of this.BillBookList){
          if(res == val.BillBookvalue){
            this.formLabelAlign.startCode = val.BillBooklabel
          }
        }
      },
      calculate(){
        if(this.formLabelAlign.sheets*1>0&&this.formLabelAlign.sheets*1!=NaN){
        let num = (this.maxMoney*1)*(this.formLabelAlign.sheets*1)
        this.startInvoiceHm = num
        this.formLabelAlign.amount = this.startInvoiceHm
        }else{
          this.$message({
          message: '张数大于0',
          type: 'warning'
        });
        }
      },
      ChargeBatchQuota(value){
        // 批量定额 选择票据簿
        this.$http.get("/charge/web/chargeInvoiceInhouse/getInvoicesByDm?invoiceDm="+value).then((res)=>{
          let data = res.data.data
          let arr =[]
          for(let val of data){
            let obj = {
              "BillBookvalue":val.id,
              "BillBooklabel":val.invoiceHm,
            }
            arr.push(obj)
          }
          this.BillBookList = arr
          for(let val of this.BatchQuotaList){
            if(value == val.BatchQuotavalue){
              this.maxMoney = val.maxMoney
            }
          }
        })
      },
    handleClose(done) {
      this.dialogVisible = false
    },
      weight(){
        // 票据类型 
        this.$http.get("/charge/web/chargeInvoiceInhouse/selectInvioce").then((res)=>{
          let date = res.data.data
          let arr = []
          for(let val of date){
            let obj = {
              "BillTypevalue":val.typeId,
              "BillTypelabel":val.typeName
            }
            arr.push(obj)
          }
          this.BillTypeList = arr
        })
      },
      BatchQuota(){
        // 批量定额 票据簿
        this.$http.get("/charge/web/chargeInvoiceInhouse/selectFixedInvoice").then((res)=>{
          let data = res.data.data
          let array =[
            {
              "BatchQuotavalue":"111",
              "BatchQuotalabel":"当前暂无可选择数据",
               disabled: true,
            }
          ]
          // console.log(data)
          if(data == null){
            data = array
            this.BatchQuotaList = array
          }else{
            let arr =[]
          for(let val of data){
            let obj = {
              "maxMoney":val.maxMoney,
              "BatchQuotavalue":val.groupNo,
              "BatchQuotalabel":val.typeName,
            }
            arr.push(obj)
          }
             this.BatchQuotaList = arr
          }
        })
      },
      ChargeItem(){
        // 收费项目
        this.$http.get("/charge/web/chargeFeeitem/getAllFeeItem").then((res)=>{
          let data = res.data.data
          this.ItemTraverse = data
          this.ChargeItemTraverse(data)
        })
      },
      chooseNode(res){
        // 选择收费项目
        for(let val of this.ItemTraverse){
          if(res[1] == val.feeCode){
            this.feeItemName = val.feeName
            this.feeItemCode = val.feeCode
          }
        }

      },
      ChargeItemTraverse(params){
        let result = []
        for(let val of params){
          if(val.feeCategory =="08"){
             var parent = {
                'label': "押金",
                "value":"08"
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="01"){
             var parent = {
                'label': "日常收费",
                'value':"01"
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="02"){
             var parent = {
                'label': "停车收费",
                'value':'02'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="03"){
             var parent = {
                'label': "装修收费",
                'value':'03'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="3"){
             var parent = {
                'label': "进户收费",
                'value':'3'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="04" || val.feeCategory =="05" ){
            if(val.feeCategory =="04"){
               var parent = {
                'label': "代收费",
                'value':'04'
              }
            }else{
              var parent = {
                'label': "代收费",
                'value':'05'
              }
            }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="06"){
             var parent = {
                'label': "其他",
                'value':'06'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="07"){
             var parent = {
                'label': "分等收费",
                'value':'07'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="09"){
             var parent = {
                'label': "西北收费",
                'value':'09'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
        result.push(parent)
        }
        this.DeWeight(result)
        this.osData = result
      },
      getchilds(id,arr){
        let childs = new Array();
        for(let val of arr){
          if (val.feeCategory == id) {
            childs.push({
                'label': val.feeName,
                'value': val.feeCode,
                'type':val.feeCategory,
                'id':val.id
            });
          }
        }
        return childs;
      },
      selectDateTime(){
      	let date = this.selectTime;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let hh = this.selectTime.getHours()
        let mf = this.selectTime.getMinutes() < 10 ? '0' + this.selectTime.getMinutes():this.selectTime.getMinutes()
        let ss = this.selectTime.getSeconds() < 10 ? '0' + this.selectTime.getSeconds():this.selectTime.getSeconds()
        let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
        this.selectTimeDate = time
    },
    inDateTime(val){
        let date = val;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let hh = val.getHours()
        let mf = val.getMinutes() < 10 ? '0' + val.getMinutes():val.getMinutes()
        let ss = val.getSeconds() < 10 ? '0' + val.getSeconds():val.getSeconds()
        let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
        this.BillDateTime = time
    },
    inTimeDate(val){
        let date = val;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
        let hh = val.getHours()
        let mf = val.getMinutes() < 10 ? '0' + val.getMinutes():val.getMinutes()
        let ss = val.getSeconds() < 10 ? '0' + val.getSeconds():val.getSeconds()
        let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
        this.ReceiptTime = time 
    },
      DeWeight(arr){
          for(var i=0; i<arr.length; i++){
            for(var j=i+1; j<arr.length; j++){
                if(arr[i].label==arr[j].label){ 
                    arr.splice(j,1);
                    j--;
                }
            }
        }
      return arr;
      },
      receiptTypeData(val){},
        RECEIPT(){
        this.$http.get("/charge/web/chargeMethod/selectList").then((res) => {
          let date = res.data.data
          let arr = []
          for(let val of date){
            let obj = {
              "receiptTypevalue":val.id,
              "receiptTypelabel":val.methodName,
            }
            arr.push(obj)
          }
          this.receiptType = arr
        })
      },
  },
    mounted() {
      this.RECEIPT()
      this.weight()
      this.ChargeItem()
      this.BatchQuota()
      
  },
   beforeMount() {
     if(this.formLabelAlign.obj == undefined){
             let obj = {
                "BillType":"票据类型",
                "NoteBook":"票据簿",
                "NoteNum":"票据号",
                "payer":"付款人",
                "DutyNum":"税号",
                "Account":"账号",
                "Site":"地址",
                "total":"合计",
                "income":"合计收入",
                "amount":"合计税额",
                "remarks":"备注",
                "receipt":"收款日期",
                "mode":"收款方式",
                "hint":"提示用户电子发票有附加信息：",
                "invoice":"开票人",
                "proceeds":"收款人",
                "invoiceDate":"开票日期"
          }
      this.formLabelAlign.obj = obj
    }
  },
}
</script>
<style scoped lang="scss">
.osBody {
  width: 250px;
  height: 400px;
  float: left;
  margin-right:1% ;
  overflow-Y:scroll;
}
</style>

